import { useTheme } from '@mui/material';
import { DatePicker, ConfigProvider } from 'antd';
import { FC } from 'react';
import Icon from '@mdi/react';
import { mdiCalendarMonthOutline } from '@mdi/js';
import momentGenerateConfig from 'rc-picker/lib/generate/moment';
import { Moment } from 'moment/moment';
import { TCustomTheme } from '@mgm/common/theme';
import { useCustomTheme } from '@mgm/common/hooks/useCustomTheme';
import { BASE_COLORS } from '@mgm/common/utils';
import { TCustomPicker } from './type';
import { useAppDispatch, useAppSelector } from '../../hooks/useAppStore';
import { getIsOpenRangePicker } from '../../store/common/selectors';
import { commonActions } from '../../store/common/slice';

const MomentPicker = DatePicker.generatePicker<Moment>(momentGenerateConfig);

const CustomPicker: FC<TCustomPicker> = ({
  extraFooter,
  defaultValue,
  setDate,
}) => {
  const theme = useTheme() as TCustomTheme;
  const { isLight } = useCustomTheme(theme);
  const isOpenPicker = useAppSelector(getIsOpenRangePicker);
  const dispatch = useAppDispatch();

  const handleChange = (date: Moment | null) => {
    dispatch(commonActions.toggleRangePicker(false));
    if (date) setDate(date);
  };

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: theme.palette.primary.main,
          fontFamily: '"Public Sans Variable", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
          colorText: isLight ? theme.palette.grey[800] : 'white',
          colorBgContainer: isLight ? 'white' : theme.palette.grey[800],
          colorBgBase: isLight ? 'white' : theme.palette.grey[800],
          colorBorderSecondary: isLight ? 'rgb(241, 243, 244)' : 'rgb(46, 50, 54)',
          colorTextPlaceholder: isLight ? theme.palette.grey[800] : 'white',
          colorTextBase: isLight ? theme.palette.grey[800] : 'white',
        },
      }}
    >
      <MomentPicker
        open={isOpenPicker}
        variant="borderless"
        value={defaultValue}
        size="large"
        onChange={handleChange}
        onOpenChange={(open: boolean) => dispatch(commonActions.toggleRangePicker(open))}
        defaultValue={defaultValue}
        style={{
          width: '100%',
        }}
        picker="month"
        suffixIcon={<Icon color={BASE_COLORS.primary} path={mdiCalendarMonthOutline} size={0.7} />}
        renderExtraFooter={() => extraFooter}
      />
    </ConfigProvider>
  );
};

export {
  CustomPicker,
};
